import { Flex } from '@radix-ui/themes'
import ReactMarkdown from 'react-markdown'
import { type MetaFunction } from 'react-router'
import { GeneralErrorBoundary } from '#app/components/ui/error-boundary.js'
import { ProseContent } from '#app/components/ui/prose-content.js'
import privacyContent from '#app/content/privacy.md?raw'

export default function PrivacyPage() {
  return (
    <main>
      <Flex flexGrow="0" justify="between" className="mb-4">
        <h1 className="text-xl font-bold leading-none">Privacy Policy</h1>
      </Flex>

      <ProseContent>
        <ReactMarkdown>{privacyContent}</ReactMarkdown>
      </ProseContent>
    </main>
  )
}

export const meta: MetaFunction = () => {
  return [{ title: 'Privacy Policy | DEx' }]
}

export function ErrorBoundary() {
  return <GeneralErrorBoundary />
}
